import LocalizedStrings from "react-localization";
import localizations from "../localization";
import {useLanguage} from "../contexts/LanguageProvider";

export default function useMonths() {
  const {language} = useLanguage();
  let translation = new LocalizedStrings(localizations);
  translation.setLanguage(language);
  return [
    translation.january,
    translation.february,
    translation.march,
    translation.april,
    translation.may,
    translation.june,
    translation.july,
    translation.august,
    translation.september,
    translation.october,
    translation.november,
    translation.december
  ];
}
